import { Box, Image, Stack, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { sanitizeHtml } from '../../../utils';
import { Card, CopyLink } from '../../../components';
import styles from './TeamInvitation.module.scss';
import { SendInviteImg } from '../../../assets';

export interface TeamInvitationProps {
  teamInvitationUrl: string;
  headline: string;
  description: string;
  imgPath: string;
}

export const TeamInvitation: FC<TeamInvitationProps> = ({
  teamInvitationUrl = '',
  headline,
  description,
  imgPath,
}) => (
  <Card py={0} px={0}>
    <Box className={styles.container}>
      <Image
        src={imgPath}
        alt="Team Invite"
        w="full"
        fallbackSrc={SendInviteImg}
      />
      <Box
        fontWeight="semibold"
        fontSize={['xl', '3xl', 'xl']}
        className={styles.centered}
      >
        {headline}
      </Box>
    </Box>

    <Stack py={6} px={[0, 0, 6]}>
      <Text fontSize="14px">{sanitizeHtml(description)}</Text>
      <Stack pt={6} spacing={4}>
        <CopyLink
          url={teamInvitationUrl}
          copyText="Your unique team invite URL"
          copyLinkText="Copy team invite link"
          buttonVariant="secondary"
          trackingLabel="teamInvite"
        />
      </Stack>
    </Stack>
  </Card>
);
